module.exports = __webpack_public_path__ + "static/img/tjsp.ed90655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/tjsp.png
// module id = 1275
// module chunks = 0